import { PostListResponseDataItem } from "@/types/codegen/data-contracts"
import { PostData } from "@/types/types"

import { Article } from "../types/new"

type PostForArticle = PostListResponseDataItem | PostData

export const mapPostToArticle = (post: PostForArticle): Article => ({
  id: post.id?.toString() || "",
  title: post.attributes?.title || "",
  slug: post.attributes?.slug || "",
  summary: post.attributes?.description || "",
  imageUrl: post.attributes?.cover?.data?.attributes?.url || "",
  publishedAt: post.attributes?.publishedAt || "",
  categoryId: post.attributes?.categories?.data?.[0]?.id?.toString() || "",
})

export const mapPostToArticleWithFormatImage = (post: PostForArticle): Article => ({
  id: post.id?.toString() || "",
  title: post.attributes?.title || "",
  slug: post.attributes?.slug || "",
  summary: post.attributes?.description || "",
  imageUrl: post.attributes?.cover?.data?.attributes?.url || "",
  publishedAt: post.attributes?.publishedAt || "",
  categoryId: post.attributes?.categories?.data?.[0]?.id?.toString() || "",
  formats: post.attributes?.cover?.data?.attributes?.formats,
})